const cacheKey = 'bookListCriteriaCache';

export function getBooklistCriteriaCache(props) {
    let criterias = {
        pageSize: props.pageSize,
        pageNumber: 1,
        order: (!props.viewMode) ? '-created' : '-download'
    };

    if (sessionStorage && sessionStorage.getItem(cacheKey) && !props.viewMode) {
        //console.log('using cache', sessionStorage.getItem(cacheKey));
        try {
            criterias = JSON.parse(sessionStorage.getItem(cacheKey));                   
        }
        catch (err) {
            return criterias;
        }
    }
    //console.log('>>>', criterias);
    return criterias;
}

export function setBooklistCriteriaCache(criterias) {
    sessionStorage.setItem(cacheKey, JSON.stringify(criterias));
}

export function getSearchString() {
    let str = '';
    if (sessionStorage && sessionStorage.getItem(cacheKey)) {
        let obj = JSON.parse(sessionStorage.getItem(cacheKey));
        str = obj.search;
    }
    return str;
}

export function cleartBooklistCriteriaCache() {
    sessionStorage.removeItem(cacheKey);
}